import React from 'react';
import { Spin } from 'antd';

import SectionTitle from '../../../components/shared/SectionTitle';
import { useApi } from '../../../hooks/useApi';

import {
  Section,
  SellersRow,
  SellerCard,
  SellerName,
  SellerLocation,
  SellerRating,
} from '../styles';

export default function SellerShowcase() {
  const { data: sellers, loading } = useApi('/sellers');

  return (
    <Section>
      <SectionTitle title="Nuestros Vendedores" />
      {loading ? (
        <Spin size="large" style={{ display: 'block', margin: '40px auto' }} />
      ) : (
        <SellersRow>
          {(sellers || []).map((seller) => (
            <SellerCard key={seller.id} to={`/vendedor/${seller.id}`}>
              <SellerName>{seller.name}</SellerName>
              <SellerLocation>{seller.location}</SellerLocation>
              <SellerRating>{seller.rating} / 5</SellerRating>
            </SellerCard>
          ))}
        </SellersRow>
      )}
    </Section>
  );
}
